module.exports = __webpack_public_path__ + "static/media/BHARATFORG.d000b9af.txt";